import { useSessionStore } from '@/entities/session';
import { useTabsStore } from '@/widgets/screen-tabs';

// When a session ends (logout, 401, admin-forced sign-out) drop per-user UI state.
useSessionStore.subscribe((state, prev) => {
  if (prev.tokens && !state.tokens) useTabsStore.getState().reset();
});
